// AI-CONTEXT: See docs/features/platform-mrr-card.md
//
// Het factuurbedrag staat in centen in Firestore (zelfde grondslag als Stripe,
// dat ook in centen rekent). Het invoerveld toont euro's met een Nederlandse
// komma. Deze twee helpers zijn de enige plek waar die vertaling gebeurt.
//
// Bewust een tekstveld en geen type="number": browsers gaan verschillend om met
// een komma als decimaalteken, en de server accepteert beide vormen al.

/**
 * Centen → wat er in het invoerveld komt te staan.
 *
 * Een leeg veld betekent "nog niet ingevuld"; nul euro is iets anders en wordt
 * dus als '0,00' getoond. Dat onderscheid draagt de MRR-tegel ook: een gratis
 * klant is bewust ingevuld, een lege staat nog open.
 *
 * @param {number|null|undefined} cents
 * @returns {string} bedrag in euro's met komma, of '' als er niets is
 */
const centsToInput = (cents) => {
    if (typeof cents !== 'number' || !Number.isFinite(cents)) return ''
    return (cents / 100).toFixed(2).replace('.', ',')
}

/**
 * De payload voor setSubscriptionInvoice.
 *
 * Bewust ONgeformatteerd doorsturen: de server valideert en weigert bijvoorbeeld
 * een derde decimaal. Hier alvast afronden zou een ander bedrag opslaan dan er
 * op het scherm stond, en dat merkt niemand.
 *
 * Lege velden gaan als lege tekst mee — dat is het signaal om te wissen.
 *
 * @param {string|null|undefined} amountInput
 * @param {string|null|undefined} periodStartInput
 * @returns {{amount: string, periodStart: string}}
 */
const inputToPayload = (amountInput, periodStartInput) => ({
    amount: typeof amountInput === 'string' ? amountInput.trim() : '',
    periodStart: typeof periodStartInput === 'string' ? periodStartInput.trim() : '',
})

/**
 * Een opgeslagen datum → de waarde van een `<input type="date">` ('YYYY-MM-DD').
 *
 * Bewust de LOKALE kalenderdag. De datum wordt als lokale middernacht
 * opgeslagen (setSubscriptionEndDate / setSubscriptionInvoice); via toISOString
 * uitlezen schuift hem in elke tijdzone vóór UTC een dag terug, en dan toont
 * het veld 31 december terwijl er 1 januari staat. Spiegel van dayStart in
 * functions/platformRevenue/invoiceMrr.js.
 *
 * @param {Date|{toDate: () => Date}|string|null|undefined} value
 * @returns {string} 'YYYY-MM-DD', of '' als er niets bruikbaars is
 */
const toDateInputValue = (value) => {
    if (!value) return ''
    if (typeof value === 'string') return value

    const date = typeof value.toDate === 'function' ? value.toDate() : value
    if (!(date instanceof Date) || Number.isNaN(date.getTime())) return ''

    const maand = String(date.getMonth() + 1).padStart(2, '0')
    const dag = String(date.getDate()).padStart(2, '0')
    return `${date.getFullYear()}-${maand}-${dag}`
}

export { centsToInput, inputToPayload, toDateInputValue }
